import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const CampaignAssignService = {
  // Assign ads to campaigns
  assignAdsToCampaigns: async (data) => {
    try {
      const response = await apiService.post("/campaign/assign", data);
      return response.data;
    } catch (error) {
      console.error("Error assigning ads to campaigns:", error);
      throw error;
    }
  },

  unAssignAdsToCampaigns: async (data) => {
    try {
      const response = await apiService.post("/campaign/unassign", data);
      return response.data;
    } catch (error) {
      console.error("Error unassigning ads to campaigns:", error);
      throw error;
    }
  },

  // Reorder ads in a campaign
  reorderCampaignAds: async (campaignId, adIds) => {
    try {
      const response = await apiService.put("/campaign/reorder", {
        campaignId,
        adIds,
      });
      return response.data;
    } catch (error) {
      console.error("Error reordering campaign ads:", error);
      throw error;
    }
  },

  // Update ad duration in a campaign
  updateAdDuration: async (campaignId, adId, durationInSec) => {
    try {
      const response = await apiService.put("/campaign/update-duration", null, {
        params: {
          campaignId,
          AdId: adId,
          DurationInSec: durationInSec,
        },
      });
      return { ...response.data, adId, durationInSec };
    } catch (error) {
      console.error("Error updating ad duration:", error);
      throw error;
    }
  },
};

export default CampaignAssignService;
